import { css, jsx } from '@emotion/core';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';

const style = {
  sorterText: css`
    font-weight: bolder;
  `,
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  header: css`
    background-color: white;
    border-bottom: solid 1px #e8e8e8;
    padding: 8px 0px 8px 32px;
  `,
  headerText: css`
    margin-bottom: 0px;
    font-size: 1.6rem;
  `,
};
const DivisionTable = ({ loading, header, staff }) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      render: (text, record) => {
        return (
          <Link anchor css={style.name} href={`mailto:${record.EmailAddress}`}>
            {text}
          </Link>
        );
      },
      width: '250px',
    },
    {
      title: 'Title',
      dataIndex: 'Title',
      width: '240px',
    },
    {
      title: 'Phone',
      dataIndex: 'Phone',
      render: text => {
        return (
          <Link anchor href={`tel:${text}`}>
            {text}
          </Link>
        );
      },
      width: '180px',
    },
  ];
  return (
    <>
      <div css={style.header}>
        <Heading type={3} weight="bolder" theme="gray" css={style.headerText}>
          {header}
        </Heading>
      </div>
      <Table
        dataSource={staff}
        showHeader={false}
        columns={columns}
        pagination={false}
        loading={loading}
        rowKey="PersonId"
        scroll={{ x: 670 }}
        css={css`
          .ant-table-row-cell-break-word {
            white-space: normal !important;
          }
        `}
      />
    </>
  );
};

DivisionTable.propTypes = {};

export default DivisionTable;
